import React from 'react'
import { Box } from '@mui/material'
import { useLocale } from 'src/locales/useLocale'

type Props = {
  contentMaxLength: number
  caution?: string
  description?: string
}

export const MetaLines: React.FC<Props> = ({ contentMaxLength, caution, description }) => {
  const { t } = useLocale()

  return (
    <>
      <Box pl={3} fontSize={'12px'} textAlign={'right'} pr={2}>
        {t.MAX_NUMBER_OF_CHAR}：{contentMaxLength}
        {t.CHARACTERS}
      </Box>
      {caution && (
        <Box pl={3} textAlign="left" color={'red'} fontSize={'12px'}>
          {caution}
        </Box>
      )}
      {description && (
        <Box pl={3} textAlign="left" color={'blue'} fontSize={'12px'}>
          {description}
        </Box>
      )}
    </>
  )
}
